import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_byhchvmeak: FaireBrandEntity = {
  token: "b_byhchvmeak",
  type: "brand",
  name: "Pittsford MRKT",
  avatarUrl:
    "https://cdn.faire.com/fastly/e20251f695d5b27684edfcb1961608de238bafec584ef0a14822ef83c86b5e83.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/84159b12a1f13ea08577468f2064c48e7c3150d1c12c386844684b0362c9d1c1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e20251f695d5b27684edfcb1961608de238bafec584ef0a14822ef83c86b5e83.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/84159b12a1f13ea08577468f2064c48e7c3150d1c12c386844684b0362c9d1c1.jpeg",
  location: "Pittsford, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "The Pittsford Candle Bar Co. was born out of the desire to create and customize beautiful scents with the best ingredients during the difficult time of the pandemic.   From the success of the brand to the opening of our first brick and mortar the Pittsford MRKT was born.  The MRKT features unique gifts, custom apparel and we are excited to now offer wholesale on our numerous best sellers!   We are a small business, family owned and operated.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:03.928Z",
    importedBy: "entity-db-cli",
  },
};
